import { render } from "./ChangeLanguage.vue?vue&type=template&id=9f6426a8"
import script from "./ChangeLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Settings/Account/ChangeLanguage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f6426a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f6426a8', __exports__)) {
    api.reload('9f6426a8', __exports__)
  }
  
  module.hot.accept("./ChangeLanguage.vue?vue&type=template&id=9f6426a8", () => {
    api.rerender('9f6426a8', render)
  })

}


export default __exports__